/** One page, one bundle.
 *
 *  The tool was two pages behind one router: the public estimate, and a workshop
 *  showing what each measured project actually cost. The workshop was the bench
 *  behind the product rather than a part of it, and it is gone (20/09/2026) —
 *  its measurements still live in `data/` and `docs/`, which is where they
 *  belong. What ships is the page a reader came for. */
import { loadLibrary, need, restoreCurrency } from './boot'
import { initLang, t } from './ui/lang'
import { renderGuide } from './ui/guide-view'

async function start(): Promise<void> {
  initLang()
  restoreCurrency()
  try {
    renderGuide(await loadLibrary())
  } catch (error) {
    // No library means nothing to estimate. Rather than a number we invented,
    // the page says what broke and how to repair it.
    const fallback = need('fallback')
    fallback.hidden = false
    fallback.textContent = t(
      'La bibliothèque de mesures ne s’est pas chargée, donc il n’y a rien à '
      + 'estimer : plutôt qu’un chiffre inventé, rien. Relancez `npm run library` puis '
      + `rechargez. (${String(error)})`,
      'The library of measurements did not load, so there is nothing to price: rather '
      + `than a number we made up, nothing. Run \`npm run library\`, then reload. `
      + `(${String(error)})`)
  }
}

void start()
